import type React from 'react';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { STEP_MAP } from './constants';

const noop = () => {};

export const StepBody: React.FC = () => {
	const { data } = useStepState();
	const CurrentStepComponent = STEP_MAP[data.currentStep.name].component;
	const preloadNextStep = data.nextStep ? STEP_MAP[data.nextStep.name].preload : noop;

	// preload the next step
	void preloadNextStep();

	return <CurrentStepComponent />;
};
